import { useEffect, useState } from 'react';
import { Alert, Button, Form, InputGroup, Spinner } from 'react-bootstrap';

import { FaCopy } from 'react-icons/fa';
import { getCreatives } from '../service/brc';

const CreativesForm = ({ campaignId, token }) => {
  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isCreativeAvailabilityChecked, setCreativeAvailabilityChecked] = useState(false);
  const [creatives, setCreatives] = useState(null);

  useEffect(() => {
    setLoading(true);
    getCreatives(campaignId)
      .then((response) => {
        setCreativeAvailabilityChecked(true);
        const { data, message } = response.data;
        if (message) {
          setErrorMessage(message);
        } else {
          setCreatives(data);
        }
      })
      .catch((e) => {
        setErrorMessage(e.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [campaignId]);

  const copyLink = (value) => () => {
    navigator.clipboard.writeText(value);
  };

  if (errorMessage) {
    return <Alert variant="danger">{errorMessage}</Alert>;
  }

  if (!isCreativeAvailabilityChecked) {
    return (
      <div>
        <Spinner role="status" animation="border" />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Spinner role="status" animation="border" />
      </div>
    );
  }

  return (
    <>
      <InputGroup className="mb-2">
        <InputGroup.Text id="newControlCreative">Control group</InputGroup.Text>
        <Form.Control readOnly value="<script src='mraid.js'></script>" />
        <Button
          aria-label="Copy control creative"
          aria-roledescription="Copy control creative"
          onClick={copyLink(creatives.controlCreative)}
        >
          <FaCopy />
        </Button>
      </InputGroup>
      <InputGroup className="mb-2">
        <InputGroup.Text id="newExposedCreative">Exposed group</InputGroup.Text>
        <Form.Control readOnly value="<script src='mraid.js'></script>" />
        <Button
          aria-label="Copy exposed creative"
          aria-roledescription="Copy exposed creative"
          onClick={copyLink(creatives.exposedCreative)}
        >
          <FaCopy />
        </Button>
      </InputGroup>
    </>
  );
};

export default CreativesForm;
